import { SVGProps } from 'react'

export const TXTIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z"
      fill="#344054"
    />
    <path
      opacity="0.3"
      d="M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z"
      fill="white"
    />
    <path
      d="M11.0911 26.5955V25.4545H16.4668V26.5955H14.4629V32H13.095V26.5955H11.0911ZM18.6497 25.4545L19.9696 27.6854H20.0208L21.3471 25.4545H22.91L20.9125 28.7273L22.9547 32H21.3631L20.0208 29.766H19.9696L18.6273 32H17.0421L19.0907 28.7273L17.0804 25.4545H18.6497ZM23.5364 26.5955V25.4545H28.9121V26.5955H26.9082V32H25.5403V26.5955H23.5364Z"
      fill="white"
    />
  </svg>
)
